import styled from "styled-components";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
  margin: 0 auto;
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  text-align: center;

  ${({ theme }) => theme.aboveBreakpoint} {
    width: 450px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  width: 64px;
  background-color: ${({ theme }) => theme.colors.redesign.b10};
  border-radius: 8px;

  svg {
    color: ${({ theme }) => theme.colors.redesign.b100};
  }
`;
